import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import {
  Text,
  Dropdown,
  Tooltip,
} from '@beef/ui-kit';
import { Icon } from 'components';
import { DETALIZATION_MODAL_COMMON } from 'constants/detalization';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const days = Array.from(
  Array(
    31,
  ).keys(),
).map((day) => ({
  slug: (day + 1).toString(),
  label: (day + 1).toString(),
}));

export const SelectDateSection = ({
  onChange,
  value,
  isMobile,
}) => {
  const endSubscriptionDay = useMemo(() => {
    const startDay = Number(value);

    return startDay > 25 ? startDay - 25 : startDay + 6;
  }, [value]);

  return (
    <>
      <Text size="size5-b">{DETALIZATION_MODAL_COMMON.REPORTING_PERIOD}</Text>
      <div className={cx('date-select-wrapper')}>
        <Text size="size5-r-l">C</Text>
        <div className={cx('date-select')}>
          <Dropdown
            onChange={onChange}
            options={days}
            emptyValueText={value}
          />
        </div>
        <Text size="size5-r-l">-го числа каждого месяца</Text>
        <div className={cx('info-icon-wrapper')}>
          <Tooltip
            message={DETALIZATION_MODAL_COMMON.REPORT_CONFIRM}
            position={isMobile ? 'left' : 'top'}
          >
            <Icon name="info" />
          </Tooltip>
        </div>
      </div>
      <Text size="size5-r-l">
        {`Детализация будет приходить в течение недели с ${value} по ${endSubscriptionDay} число каждого месяца`}
      </Text>
    </>
  );
};

SelectDateSection.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  isMobile: PropTypes.bool,
};
